import { Icon, Box, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ChevronLeftIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" width="20px" height="20px" fill="none" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m12.5 5-5 5 5 5"
      />
    </Icon>
  );
}
